export default {
      id: "dns-usage",
      viewBox: "0 0 122.879 122.881",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#dns",
      toString: function () {
        return this.url;
      }
    }